import React from 'react';
import { Box, Button, Modal } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { coursesColumn } from './columns';
import { getAllCoursesAsync } from './CourseStore/courseStoreSlice';
import { useDispatch, useSelector } from 'react-redux';
import AddCourseForm from './AddCourseForm';

const Course = () => {
  const [addCourseOpen, setAddCourseOpen] = React.useState(false);

  const handleAddCourseOpen = () => setAddCourseOpen(true);
  const handleAddCourseClose = () => setAddCourseOpen(false);

  const dispatch = useDispatch();
  const { courses } = useSelector((state) => {
    const { coursesReducer } = state;

    return {
      courses: coursesReducer.courses,
    };
  });

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      dispatch(getAllCoursesAsync())
        .unwrap()
        .then(() => {});
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {/* disabled true for not breaking the ui in ath-global */}
      <Button
        onClick={handleAddCourseOpen}
        variant="contained"
        color="primary"
        disabled={true}>
        Add Course
      </Button>
      <Box my={4}>
        <BuzzTable columns={coursesColumn} data={courses} />
      </Box>
      <Modal
        open={addCourseOpen}
        onClose={handleAddCourseClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <AddCourseForm
          fetchDefaultData={fetchData}
          handleClose={handleAddCourseClose}
        />
      </Modal>
    </>
  );
};

export default Course;
